import React from "react";
import Navbar from "./Navbar/Navbar";
import "./Feedback.scss";
import Footer from "./Footer/Footer";
import RatingTab from "./RatingTab/RatingTab";
import { useState } from "react";
import InsightsTab from "./InsightsTab/InsightsTab";
import { useEffect } from "react";
import { RouteComponentProps, useParams, withRouter } from "react-router";
import Cookies from "js-cookie";
import config from "../../config/apiConfig";

const Feedback: React.FC<RouteComponentProps> = ({ history }) => {
    const { id } = useParams<{ id: string }>();

    const [tab, setTab] = useState(0);

    const [conflictInteresting, setConflictInteresting] =
        useState<number | undefined>(undefined);
    const [storyUnique, setStoryUnique] =
        useState<number | undefined>(undefined);
    const [storyRelevant, setStoryRelevant] =
        useState<number | undefined>(undefined);
    const [storyEngaging, setStoryEngaging] =
        useState<number | undefined>(undefined);
    const [plotPredictable, setPlotPredictable] =
        useState<number | undefined>(undefined);
    const [overallRating, setOverallRating] =
        useState<number | undefined>(undefined);

    const [storyLike, setStoryLike] = useState("");
    const [storyDislike, setStoryDislike] = useState("");
    const [protagonist, setProtagonist] = useState("");
    const [storyCharacters, setStoryCharacters] = useState("");

    const handleNext = () => {
        if (
            conflictInteresting !== undefined &&
            storyUnique !== undefined &&
            storyRelevant !== undefined &&
            storyEngaging !== undefined &&
            plotPredictable !== undefined &&
            overallRating !== undefined
        ) {
            setTab(1);
        } else {
            alert("All rating fields are required");
        }
    };

    const handlePublish = async () => {
        const payload = {
            conflict_interesting: conflictInteresting,
            story_unique: storyUnique,
            story_relevant: storyRelevant,
            story_engaging: storyEngaging,
            plot_predictable: plotPredictable,
            story_overall: overallRating,
            review_story_like: storyLike,
            review_story_dislike: storyDislike,
            review_protagonist: protagonist,
            review_story_characters: storyCharacters,
        };
        const formData = new FormData();
        formData.append("session-token", Cookies.get("token") ?? "");
        formData.append("token", config.token);
        formData.append("payload", JSON.stringify(payload));
        const requestParams = {
            method: "POST",
            body: formData,
        };
        await fetch(
            config.BASE_URL + "/v1/put/showmilers/story/" + id + "/review/new",
            requestParams
        );
        history.goBack();
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [tab]);

    return (
        <div className="feedback__page">
            <Navbar />
            <main className="main__content">
                {tab === 0 ? (
                    <RatingTab
                        ratings={[
                            {
                                question:
                                    "How interesting is the problem/conflict?",
                                rate: conflictInteresting,
                                setRate: setConflictInteresting,
                            },
                            {
                                question: "How unique is the story?",
                                rate: storyUnique,
                                setRate: setStoryUnique,
                            },
                            {
                                question: "How relevant is the story?",
                                rate: storyRelevant,
                                setRate: setStoryRelevant,
                            },
                            {
                                question: "How engaging is the story?",
                                rate: storyEngaging,
                                setRate: setStoryEngaging,
                            },
                            {
                                question: "How much plot is predictable?",
                                rate: plotPredictable,
                                setRate: setPlotPredictable,
                            },
                            {
                                question: "Overall Rating of the Story:",
                                rate: overallRating,
                                setRate: setOverallRating,
                            },
                        ]}
                    />
                ) : (
                    <InsightsTab
                        insights={[
                            {
                                question: "What did you like about the story?",
                                text: storyLike,
                                setText: setStoryLike,
                            },
                            {
                                question:
                                    "What did you not like about the story?",
                                text: storyDislike,
                                setText: setStoryDislike,
                            },
                            {
                                question:
                                    "Which characters in the story stay with you and why?",
                                text: storyCharacters,
                                setText: setStoryCharacters,
                            },
                            {
                                question:
                                    "Do you care what happens to the protagonist and why?",
                                text: protagonist,
                                setText: setProtagonist,
                            },
                        ]}
                    />
                )}
            </main>
            <Footer
                tab={tab}
                goToNext={() => handleNext()}
                goBack={() => setTab(0)}
                publish={handlePublish}
            />
        </div>
    );
};

export default withRouter(Feedback);
